import React from "react";
import { Provider } from "react-redux";
import GlobalStyles from "@theme/global/globalStyles";
import store from "@redux/store";
import Boot from "@redux/boot";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./routes";
import { AppProvider } from "./AppProvider";
import { ModalParent } from "@components/modal";
import useScript from "@hooks/useScript";
import { isProduction } from "@utils/helpers/environment";
import { MapsApiScriptElement } from "./components/mapsApiScriptElement";
import environmentSettings from "./constants/environmentSettings";

export const App = () => {
  useScript(
    "//js.hs-scripts.com/7705693.js",
    "hs-script-loader",
    isProduction(),
    true
  );
  useScript(
    "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
    "hs-script-loader",
    true,
    true
  );
  useScript(
    environmentSettings.salesforceBeaconScript,
    "sf-beacon",
    true
  );

  return (
    <Provider store={store}>
        <AppProvider>
          <MapsApiScriptElement />
          <GlobalStyles />
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <ModalParent />
        </AppProvider>
    </Provider>
  );
};
Boot()
  // .then(() => {
  //   // No direct invocation of App here, handled in index.js
  // })
  .then(() => App())
  .catch((error) => console.error(error));
